$.fn.displayProp = function () {
	var self, target, items;

	self = $( this );
	target = self.data( 'prop-target' );
	items = self.find( '.item' );

	$.each( items, function ( i, el ) {
		$( el ).on( 'mouseenter', function () {
			$( target ).text( $( this ).data( 'prop' ) );
		} ).on( 'mouseleave', function () {
			$( target ).text( self.find( 'input[type=radio]:checked' ).parents( 'li' ).data( 'prop' ) );
		} );
	} );
};



// WEBPACK FOOTER //
// ./scripts/util/displayProp.js